// @flow

import * as React from 'react';

import { Base } from '@gandi/ui';

import Price from './Price';

export type Props = {
  label: React.Node,
  detail?: React.Node,
  priceMention?: string,
  price?: ?number,
};

export default function DetailRow({
  label,
  detail,
  price,
  priceMention,
}: Props): React.MixedElement {
  return (
    <Base flex marginBottom="xsmall" gap="xsmall">
      <Base>
        <Base tagName="span">{label}</Base>
        {!!detail && (
          <Base marginTop="xxsmall" size="small" color="light">
            {detail}
          </Base>
        )}
      </Base>
      {!!price && (
        <Base flexExpandLeft flexAlignSelfCenter>
          {priceMention && <Base>{priceMention}</Base>}
          {!priceMention && <Price price={price} showExcludeVatMention />}
        </Base>
      )}
    </Base>
  );
}
